import { Component, Input } from '@angular/core';
import { StatusPill } from '../../models/shared/status-pill';

export type StatusPillSize = 'small' | 'medium';

@Component({
  selector: 'app-status-pill',
  templateUrl: './status-pill.component.html',
  styleUrls: ['./status-pill.component.scss'],
  standalone: true
})
export class StatusPillComponent {
  @Input() statusPill!: StatusPill;
  @Input() size: StatusPillSize = 'small';
}
